import { requests } from '../config'
import { IWorkerOrdersPutData } from './models/requests'
import { IWorkerHistoryResponse } from './models/workerHistory'

export const Workers = {
  updateWorkerOrders: (data: IWorkerOrdersPutData): Promise<unknown> =>
    requests.put('worker', 'go', data),
  getWorkerHistoryByOrderID: (orderID: number | string): Promise<IWorkerHistoryResponse> =>
    requests.get(`worker/history/${orderID}`, 'go'),
}
